export const coachmarkEndpoint = {
  get: {
    getCoachmark: 'tooltip/v1/mark/get',
  },
  post: {
    updateCoachmark: 'tooltip/v1/mark/update',
  },
};
